import type { Lead } from '@/types/lead';

/**
 * A lead is "open" (linkable to an estimate) when it has no outcome and its
 * stage is neither won nor lost. Mirrors the backend rule enforced by
 * `syncLeadEstimateLink` (closed leads are rejected with "Cannot link a closed
 * lead").
 */
export function isOpenLead(lead: Lead): boolean {
  return !lead.outcome && !lead.stage?.isWon && !lead.stage?.isLost;
}
